import styled from "styled-components";
import { ISwitch } from "./switchComponent";
import { Switch } from "@mui/material";



export const StyledSwitch = styled(Switch)<ISwitch>`
    ${({theme, commonStyles}) => `
    .MuiSwitch-switchBase{
        top: 12px;
        left: 12px;
        border: 1px solid ${theme.uptimeColors.grayScales.darkerGray};
        padding: 0px !important;
    }
    .MuiSwitch-switchBase.Mui-checked{
        transform: translateX(12px);
    }
    .MuiSwitch-thumb{
        width: 12px;
        height: 12px;
    }
    .MuiSwitch-track{
        background-color: ${theme.uptimeColors.grayScales.darkGray};
        width: 26px;
        height: 14px;
    }
    .MuiSwitch-colorSecondary.Mui-checked{
        color: ${theme.uptimeColors.grayScales.white};
        border: 1px solid ${theme.uptimeColors.mainTheme.primary};
    }
    .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track{
        background-color: ${theme.uptimeColors.mainTheme.primary};
        opacity: 1;
    }
    `}
`